import * as yup from 'yup';

export const playBulkloadSchema = yup.object({
  companyId: yup.string().required('Empresa/Institución es requerido'),
  playerDataFile: yup
  .mixed()
  .nullable()
  .when('urlCoverPhoto', {
    is: (urlCoverPhoto:any) => !urlCoverPhoto, // if urlCoverPhoto is empty
    then: (schema) => schema
      .required('Archivo es requerido')
      .test('fileSize', 'Archivo no debe pesar más de 20MB', (value: any) => {
        if (!value) return false;
        return value.size <= 20 * 1024 * 1024; // 20MB max
      })
      .test('fileType', 'Formato del archivo no es válido', (value: any) => {
        if (!value) return false;
        const supportedFormats = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        return supportedFormats.includes(value.type);
      }),
    otherwise: (schema) => schema.notRequired(),
  }),});